import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Box, Paper,
  Grid,
  AccordionActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  withStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SideDisplayGrid from '../../../../../components/organisms/sideDisplayGrid/SideDisplayGrid';
import {
  actCallSaveEntry, actResetMemberEntryFlg,
} from '../../../../../redux/member/entry/action';

// #region css
const styles = () => ({
  accordionRoot: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    marginTop: '20px',
  },
});
// #endregion

class ConfirmForm extends React.Component {
  constructor(props) {
    super(props);
    let isMain = false;
    if (props.common.user) {
      isMain = props.common.user.main;
    }
    this.state = {
      isMain,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.common.user !== this.props.common.user) {
      if (this.props.common.user) {
        this.setStore(this.props.common.user);
      }
    }
  }

  setStore = (user) => {
    this.setState({ isMain: user.main });
  }

  onClickNextComplete = () => {
    const { isSameContractUser } = this.props;
    const { memberEntry } = this.props.entry;
    const { contract, members } = memberEntry;
    const tempContract = {
      ...contract,
      mstCodePrefectureCode: contract.mstCodePrefectureCode.id,
    };

    if (isSameContractUser === '0') {
      members[0] = contract;
    }

    const tempMembers = members.map((member) => ({
      ...member,
      mstCodePrefectureCode: member.mstCodePrefectureCode && member.mstCodePrefectureCode.id,
    }));

    const tempMemberEntry = {
      ...memberEntry,
      mstStoreId: memberEntry.mstStoreId.id,
      contract: tempContract,
      members: tempMembers,
    };

    this.props.dispatch(actResetMemberEntryFlg());
    this.props.dispatch(actCallSaveEntry(tempMemberEntry));
  }

  onClickBackContract = () => {
    const { onClickGoBackFromConfirm } = this.props;
    onClickGoBackFromConfirm(0, true);
  }

  onClickBackUser = () => {
    const { onClickGoBackFromConfirm } = this.props;
    onClickGoBackFromConfirm(1, true);
  }

  render() {
    const {
      classes,
      isSameContractUser,
      initSelectValues,
      common,
    } = this.props;
    const { user } = common;
    const companyId = user ? user.store.mstOrganizationCompanyId : 1;
    const { memberEntry } = this.props.entry;
    const { isMain } = this.state;
    const {
      mstCodeContractCode,
      userType,
    } = memberEntry;

    return (
      <Box mt={3}>
        <Paper elevation={0} variant="outlined" style={{ display: isMain ? '' : 'none' }}>
          <Box p={3}>
            <Grid container spacing={0}>
              <SideDisplayGrid title="ご利用店舗" content={memberEntry.mstStoreId && memberEntry.mstStoreId.name} />
            </Grid>
          </Box>
        </Paper>

        <Accordion defaultExpanded className={classes.accordionRoot}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1b-content"
            id="panel1b-header"
          >
            <Box fontWeight="fontWeightBold" fontSize="h6.fontSize">ご契約者様情報</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={0}>
              <SideDisplayGrid isNotShow={memberEntry.contract.corporationName === ''} title="法人名" content={memberEntry.contract.corporationName} />
              <SideDisplayGrid title="氏名" content={`${memberEntry.contract.lastName} ${memberEntry.contract.firstName}`} />
              <SideDisplayGrid title="氏名カナ" content={`${memberEntry.contract.lastNameKana} ${memberEntry.contract.firstNameKana}`} />
              <SideDisplayGrid title="郵便番号" content={`${memberEntry.contract.zipCodeBefore}-${memberEntry.contract.zipCodeAfter}`} />
              <SideDisplayGrid title="都道府県" content={memberEntry.contract.mstCodePrefectureCode && memberEntry.contract.mstCodePrefectureCode.name} />
              <SideDisplayGrid title="市区町村" content={memberEntry.contract.city} />
              <SideDisplayGrid title="町名・番地・その他" content={memberEntry.contract.street} />
              <SideDisplayGrid title=" メールアドレス" content={memberEntry.contract.email} />
              <SideDisplayGrid title=" 電話番号" content={`${memberEntry.contract.phoneBefore}-${memberEntry.contract.phoneMiddle}-${memberEntry.contract.phoneAfter}`} />
              <SideDisplayGrid
                title="電話番号2"
                content={
                  memberEntry.contract.phoneTwoBefore && `${memberEntry.contract.phoneTwoBefore}-${memberEntry.contract.phoneTwoMiddle}-${memberEntry.contract.phoneTwoAfter}`
                }
              />
              <SideDisplayGrid title="生年月日" content={`${memberEntry.contract.birthdayYear}年${memberEntry.contract.birthdayMonth}月${memberEntry.contract.birthdayDay}日`} />
              <SideDisplayGrid
                title="性別"
                content={
                  initSelectValues.genderSelectList
                    .filter((option) => option.id === memberEntry.contract.mstCodeGenderCode)
                    .map((data) => data.name)[0]
                }
              />
              <SideDisplayGrid title="緊急連絡先氏名" content={`${memberEntry.contract.emergencyLastName} ${memberEntry.contract.emergencyFirstName}`} />
              <SideDisplayGrid title="緊急連絡先電話番号" content={`${memberEntry.contract.emergencyPhoneBefore}-${memberEntry.contract.emergencyPhoneMiddle}-${memberEntry.contract.emergencyPhoneAfter}`} />
            </Grid>
          </AccordionDetails>
          <AccordionActions>
            <Box>
              <Button onClick={this.onClickBackContract} color="primary">ご契約者様情報を修正する</Button>
            </Box>
          </AccordionActions>
        </Accordion>

        <Paper elevation={0} variant="outlined" style={{ display: mstCodeContractCode === 3 || isSameContractUser === '0' ? '' : 'none' }}>
          <Box px={3} pb={3}>
            <Box mt={3} fontWeight="fontWeightBold" fontSize="h6.fontSize">ご利用者様情報</Box>
            <Box display={isSameContractUser === '0' ? '' : 'none'}>
              <hr />
              ご契約者様と同じ
            </Box>
            <Box display={mstCodeContractCode === 3 ? '' : 'none'}>
              <hr />
              <Grid container spacing={0}>
                <SideDisplayGrid
                  title="ご利用タイプ"
                  content={
                    initSelectValues.applicantTypeSelectList
                      .filter((option) => (option.id === userType))
                      .map((data) => data.name)[0]
                  }
                />
              </Grid>
            </Box>
            <Box display="flex" flexDirection="row-reverse">
              <Button onClick={this.onClickBackUser} color="primary">ご利用者情報を修正する</Button>
            </Box>
          </Box>
        </Paper>

        {((isSameContractUser === '1' && mstCodeContractCode === 1) || mstCodeContractCode === 2) && memberEntry.members.map((member, index) => {
          const keyIdx = index + 1;
          return (
            <Accordion className={classes.accordionRoot} defaultExpanded key={keyIdx}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Box fontWeight="fontWeightBold" fontSize="h6.fontSize">
                  {`${index + 1}人目確認画面`}
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={0}>
                  <SideDisplayGrid title="氏名" content={`${member.lastName} ${member.firstName}`} />
                  <SideDisplayGrid title="氏名カナ" content={`${member.lastNameKana} ${member.firstNameKana}`} />
                  <SideDisplayGrid title="郵便番号" content={member.zipCodeBefore && `${member.zipCodeBefore}-${member.zipCodeAfter}`} />
                  <SideDisplayGrid title="都道府県" content={member.mstCodePrefectureCode && member.mstCodePrefectureCode.name} />
                  <SideDisplayGrid title="市区町村" content={member.city} />
                  <SideDisplayGrid title="町名・番地・その他" content={member.street} />
                  {companyId !== 4 && (<SideDisplayGrid title="メールアドレス" content={member.email} />)}
                  <SideDisplayGrid title="電話番号" content={member.phoneBefore && `${member.phoneBefore}-${member.phoneMiddle}-${member.phoneAfter}`} />
                  <SideDisplayGrid title="電話番号2" content={member.phoneTwoBefore && `${member.phoneTwoBefore}-${member.phoneTwoMiddle}-${member.phoneTwoAfter}`} />
                  <SideDisplayGrid title="生年月日" content={member.birthdayYear && `${member.birthdayYear}年${member.birthdayMonth}月${member.birthdayDay}日`} />
                  <SideDisplayGrid
                    title="性別"
                    content={
                      initSelectValues.genderSelectList.filter(
                        (option) => option.id === member.mstCodeGenderCode,
                      ).map((data) => data.name)[0]
                    }
                  />
                </Grid>
              </AccordionDetails>
              <AccordionActions>
                <Box>
                  <Button onClick={this.onClickBackUser} color="primary">ご利用者情報を修正する</Button>
                </Box>
              </AccordionActions>
            </Accordion>
          );
        })}

        <Box align="center" my={2}>
          <Button
            color="primary"
            variant="contained"
            onClick={this.onClickNextComplete}
          >
            登録する
          </Button>
        </Box>
      </Box>
    );
  }
}
const mapStateToProps = (state) => ({
  entry: state.entry,
  common: state.common,
});

export default withStyles(styles)(withRouter(connect(mapStateToProps)(ConfirmForm)));
